import React, { useEffect, useState } from 'react';
import { exposureFactorTable, tablaDeFactorTipoMaterial } from './InsuranceFactorsTables';
import './style.css';
import ContainerFees from './ContainerFees';
import ContainerPrimas from './ContainerPrimas';
import MaterialDetails from './MaterialDetails';
import OtherFactore from './OtherFactore';
import BlackButton from '../../components/ui-components/buttons/BlackButton';
const InsuranceRater = () => {
  // const [productCost, setProductCost] = useState(1088);
  // const [selectedMaterial, setSelectedMaterial] = useState(null);
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  // const [daysBetween, setDaysBetween] = useState(null);
  // const [factorFranquicia, setFactorFranquicia] = useState(null);

  // const handelGetProductPrice = e => {
  //   const evnt = parseInt(e.target.value, 10);
  //   setProductCost(evnt);
  // };
  // const calculateDifference = () => {
  //   if (startDate && endDate) {
  //     const start = new Date(startDate);
  //     const end = new Date(endDate);
  //     const differenceInTime = end - start;
  //     const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  //     setDaysBetween(differenceInDays + 1);
  //   }
  // };

  // const handleSelectChange = event => {
  //   const selectedIndex = event.target.value;
  //   const selectedOption = tablaDeFactorTipoMaterial[selectedIndex];
  //   setSelectedMaterial(selectedOption);
  // };
  // const getExposureFactor = days => {
  //   const factorObject = exposureFactorTable.find(({ rentingDays }) => {
  //     const { from, to } = rentingDays;
  //     return to ? days >= from && days <= to : days === from;
  //   });
  //   return factorObject ? factorObject.factorDeExposicion : null;
  // };

  // useEffect(() => {
  //   const exposureFactor = getExposureFactor(daysBetween);
  //   setFactorFranquicia(exposureFactor);
  // }, [daysBetween]);
  // const primaCoberturaDanos =
  //   0.12727 * productCost * factorFranquicia * 0.9 * selectedMaterial?.factorDanosMateriales;
  // const primaCoberturaRobo =
  //   0.0118182 * productCost * factorFranquicia * 0.9 * selectedMaterial?.factorDanosMateriales;
  // const primaTotal = primaCoberturaRobo + primaCoberturaDanos;
  // const Ips = primaTotal * 0.08;
  // const LEA = primaTotal * 0.0015;
  // const consorcio = productCost * 0.00018;
  // const honorariosCorredor = primaTotal * 0.05;
  // const totalRecibo = primaTotal + Ips + LEA + consorcio + honorariosCorredor;

  // const feesData = [
  //   {
  //     name: 'Ips',
  //     value: Ips,
  //     formula: `${primaTotal} * 0.08 =`,
  //   },
  //   { name: 'LEA', value: LEA },
  //   { name: 'Consorcio', value: consorcio },
  //   { name: 'Honorarios Corredor', value: LEA },
  //   { name: 'Total Recibo', value: totalRecibo },
  // ];
  // const primasData = [
  //   {
  //     name: 'Prima cobertura (Daños)',
  //     value: primaCoberturaDanos,
  //     formula: `
  //               0.0118182
  //                  *
  //                 ${productCost}
  //                  * '
  //                 ${factorFranquicia} +
  //                  * '
  //                 0.9
  //                  *
  //                 ${selectedMaterial?.factorDanosMateriales}`,
  //   },
  //   {
  //     name: 'Prima cobertura (Robo)',
  //     value: primaCoberturaRobo,
  //     formula: `${0.12727 +
  //       ' * ' +
  //       productCost +
  //       ' * ' +
  //       factorFranquicia +
  //       ' * ' +
  //       0.9 +
  //       ' * ' +
  //       selectedMaterial?.factorDanosMateriales}`,
  //   },

  //   { name: 'Total primas', value: primaCoberturaRobo + primaCoberturaDanos },
  // // ];
  // const [productCost, setProductCost] = useState(1088);
  // const [selectedMaterial, setSelectedMaterial] = useState(null);
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  // const [daysBetween, setDaysBetween] = useState(null);
  // const [factorFranquicia, setFactorFranquicia] = useState(null);

  // const handelGetProductPrice = e => {
  //   const evnt = parseInt(e.target.value, 10);
  //   setProductCost(evnt);
  // };

  // const calculateDifference = () => {
  //   if (startDate && endDate) {
  //     const start = new Date(startDate);
  //     const end = new Date(endDate);
  //     const differenceInTime = end - start;
  //     const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  //     setDaysBetween(differenceInDays + 1);
  //   }
  // };

  // const handleSelectChange = event => {
  //   const selectedIndex = event.target.value;
  //   const selectedOption = tablaDeFactorTipoMaterial[selectedIndex];
  //   setSelectedMaterial(selectedOption);
  // };

  // const getExposureFactor = days => {
  //   const factorObject = exposureFactorTable.find(({ rentingDays }) => {
  //     const { from, to } = rentingDays;
  //     return to ? days >= from && days <= to : days === from;
  //   });
  //   return factorObject ? factorObject.factorDeExposicion : null;
  // };

  // useEffect(() => {
  //   const exposureFactor = getExposureFactor(daysBetween);
  //   setFactorFranquicia(exposureFactor);
  // }, [daysBetween]);

  // const primaCoberturaDanos =
  //   Math.round(
  //     0.12727 * productCost * factorFranquicia * 0.9 * selectedMaterial?.factorDanosMateriales * 100
  //   ) / 100;
  // const primaCoberturaRobo =
  //   Math.round(
  //     0.0118182 *
  //       productCost *
  //       factorFranquicia *
  //       0.9 *
  //       selectedMaterial?.factorDanosMateriales *
  //       100
  //   ) / 100;
  // const primaTotal = Math.round(primaCoberturaRobo + primaCoberturaDanos * 100) / 100;
  // const Ips = Math.round(primaTotal * 0.08 * 100) / 100;
  // const LEA = Math.round(primaTotal * 0.0015 * 100) / 100;
  // const consorcio = Math.round(productCost * 0.00018 * 100) / 100;
  // const honorariosCorredor = Math.round(primaTotal * 0.05 * 100) / 100;
  // const totalRecibo =
  //   Math.round((primaTotal + Ips + LEA + consorcio + honorariosCorredor) * 100) / 100;

  // const feesData = [
  //   {
  //     name: 'Ips',
  //     value: Ips,
  //     formula: `${primaTotal} * 0.08 =`,
  //   },
  //   { name: 'LEA', value: LEA },
  //   { name: 'Consorcio', value: consorcio },
  //   { name: 'Honorarios Corredor', value: honorariosCorredor },
  //   { name: 'Total Recibo', value: totalRecibo },
  // ];

  // const primasData = [
  //   {
  //     name: 'Prima cobertura (Daños)',
  //     value: primaCoberturaDanos,
  //     formula: `
  //              0.12727
  //                  *
  //                 ${productCost}
  //                  *
  //                 ${factorFranquicia}
  //                  *
  //                 0.9
  //                  *
  //                 ${selectedMaterial?.factorDanosMateriales}`,
  //   },
  //   {
  //     name: 'Prima cobertura (Robo)',
  //     value: primaCoberturaRobo,
  //     formula: `${0.0118182}
  //                *
  //               ${productCost}
  //                *
  //               ${factorFranquicia}
  //                *
  //               0.9
  //                *
  //               ${selectedMaterial?.factorDanosMateriales}`,
  //   },

  //   { name: 'Total primas', value: primaTotal },
  // ];
  const [productCost, setProductCost] = useState(1088);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [daysBetween, setDaysBetween] = useState(null);
  const [factorFranquicia, setFactorFranquicia] = useState(null);

  const handelGetProductPrice = e => {
    const evnt = parseInt(e.target.value, 10);
    setProductCost(evnt);
  };

  const calculateDifference = () => {
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const differenceInTime = end - start;
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);
      setDaysBetween(differenceInDays + 1);
    }
  };

  const handleSelectChange = event => {
    const selectedIndex = event.target.value;
    const selectedOption = tablaDeFactorTipoMaterial[selectedIndex];
    setSelectedMaterial(selectedOption);
  };

  const getExposureFactor = days => {
    const factorObject = exposureFactorTable.find(({ rentingDays }) => {
      const { from, to } = rentingDays;
      return to ? days >= from && days <= to : days === from;
    });
    return factorObject ? factorObject.factorDeExposicion : null;
  };

  useEffect(() => {
    const exposureFactor = getExposureFactor(daysBetween);
    setFactorFranquicia(exposureFactor);
  }, [daysBetween]);

  const primaCoberturaDanos = (
    0.12727 *
    productCost *
    factorFranquicia *
    0.9 *
    selectedMaterial?.factorDanosMateriales
  ).toFixed(2);
  const primaCoberturaRobo = (
    0.0118182 *
    productCost *
    factorFranquicia *
    0.9 *
    selectedMaterial?.FactorRoboYExpoliacion
  ).toFixed(2);
  const primaTotal = (parseFloat(primaCoberturaRobo) + parseFloat(primaCoberturaDanos)).toFixed(2);
  const Ips = (primaTotal * 0.08).toFixed(2);
  const LEA = (primaTotal * 0.0015).toFixed(2);
  const consorcio = (productCost * 0.00018).toFixed(2);
  const honorariosCorredor = (primaTotal * 0.05).toFixed(2);
  const totalRecibo = (
    parseFloat(primaTotal) +
    parseFloat(Ips) +
    parseFloat(LEA) +
    parseFloat(consorcio) +
    parseFloat(honorariosCorredor)
  ).toFixed(2);
  console.log('totalRecibo', totalRecibo);

  const feesData = [
    {
      name: 'Ips',
      value: Ips,
      formula: `${primaTotal} * 0.08 =`,
    },
    { name: 'LEA', value: LEA },
    { name: 'Consorcio', value: consorcio },
    { name: 'Honorarios Corredor', value: honorariosCorredor },
    { name: 'Total Recibo', value: totalRecibo },
  ];

  const primasData = [
    {
      name: 'Prima cobertura (Daños)',
      value: primaCoberturaDanos,
      formula: `
                0.12727
                   * 
                  ${productCost} 
                   * 
                  ${factorFranquicia} 
                   * 
                  0.9 
                   * 
                  ${selectedMaterial?.factorDanosMateriales}`,
    },
    {
      name: 'Prima cobertura (Robo)',
      value: primaCoberturaRobo,
      formula: `${0.0118182} 
                 * 
                ${productCost} 
                 * 
                ${factorFranquicia} 
                 * 
                0.9 
                 * 
                ${selectedMaterial?.FactorRoboYExpoliacion}`,
    },

    {
      name: 'Total primas',
      value: primaTotal,
    },
  ];

  return (
    <div className="container">
      <div className="container_materail_type_price">
        <p className="text">Seleccionar tipo de material</p>
        <select onChange={handleSelectChange}>
          <option value="">Select an option</option>
          {tablaDeFactorTipoMaterial.map((item, index) => (
            <option key={index} value={index}>
              {item.Tipo} - {item.Subtipo}
            </option>
          ))}
        </select>
        <input
          value={productCost}
          type="number"
          placeholder="Price of the poduct"
          onChange={handelGetProductPrice}
        />
      </div>

      {selectedMaterial && (
        <div className={'date_container'}>
          <div className="input_dates_container">
            <label>
              Fecha de inicio:
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
            </label>
            <label>
              Fecha final:
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
            </label>
          </div>
          {startDate &&
            endDate &&
            daysBetween <= 0 &&
            daysBetween != null &&
            'intrecuide una fecha válida'}
          <BlackButton onClick={calculateDifference} Text={'Calcular la diferencia'} />
        </div>
      )}
      {daysBetween >= 1 && (
        <div className="container_materail_details">
          <MaterialDetails selectedMaterial={selectedMaterial} />
          <OtherFactore daysBetween={daysBetween} factorFranquicia={factorFranquicia} />
          <ContainerPrimas primasData={primasData} />
          <ContainerFees feesData={feesData} />
        </div>
      )}
    </div>
  );
};

export default InsuranceRater;
